<div class="container">
  <mat-card>
    <form [formGroup]="groupsAddRoleForm" (ngSubmit)="submit()">
      <mat-card-content>
        <div fxLayout="column">
          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Client' | translate }}</mat-label>
            <mat-select formControlName="clientId">
              <mat-option *ngFor="let client of clientMemberData" [value]="client.id">
                {{ client.displayName }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="groupsAddRoleForm.controls.clientId.hasError('required')">
              {{ 'labels.inputs.Client Member' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field>
            <mat-label>{{ 'labels.inputs.Role' | translate }}</mat-label>
            <mat-select formControlName="role">
              <mat-option *ngFor="let role of roleData" [value]="role.id">
                {{ role.name }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="groupsAddRoleForm.controls.role.hasError('required')">
              {{ 'labels.inputs.Role' | translate }} {{ 'labels.commons.is' | translate }}
              <strong>{{ 'labels.commons.required' | translate }}</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </mat-card-content>

      <mat-card-actions fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center" fxLayoutGap="5px">
        <button type="button" mat-raised-button [routerLink]="['../']">
          {{ 'labels.buttons.Cancel' | translate }}
        </button>
        <button
          mat-raised-button
          color="primary"
          [disabled]="!groupsAddRoleForm.valid"
          *mifosxHasPermission="'ASSIGNROLE_GROUP'"
        >
          {{ 'labels.buttons.Confirm' | translate }}
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
</div>
